import React, { Component } from 'react';
import { firebase, firebaseListToArray } from '../utils/firebase';
import SongEditForm from './SongEditForm';
import SubmitModal from './SubmitModal';
import ChordDiagram from './ChordDiagram';
import DefaultSongs from './DefaultSongs';
import DefaultGig from './DefaultGig';
import jQuery from 'jquery';

class Song extends Component {
  constructor(props){
    super(props);
    this.state={
      song:[],
      submitted:false
    }
  }

  componentWillMount(){
    let song = '';
    let songid = this.props.song;
    console.log('songid: ',songid);
    console.log('userid: ',this.props.id);
    let uid = this.props.id;

    firebase.database()
    .ref(uid+'/songs/'+songid)
    .on('value',(data)=>{
      song = data.val();
      console.log('Song.js song: ',song);
    });
    if(song !== null && song !==''){
      console.log('the song is not null: ',song);
    this.setState({
      song:song,
      songid:songid
    });
  }else{
    console.log('the song equals nothing');
    let songs=DefaultSongs.songs;
    console.log('default songs: ',songs);
    for(let val in songs){
      console.log('default val: ',val);
      if(val.id===songid){
        console.log(song + '===' + val);
        song=val;
      }
    }
    this.setState({
      song:song,
      songs:songs
    });
  }
  }
  componentDidMount(){
    let song = '';
    let songid = this.props.song;
    console.log('songid: ',songid);
    console.log('userid: ',this.props.id);
    let uid = this.props.id;

    firebase.database()
    .ref(uid+'/songs/'+songid)
    .on('value',(data)=>{
      song = data.val();
      console.log('Song.js song: ',song);
    });
    if(song !== null && song !==''){
    this.setState({
      song:song,
      songid:songid
    });
  }else{
    console.log('the song equals nothing');
    let songs=DefaultSongs.songs;
    console.log('default songs: ',songs);
    songs.forEach((val)=>{
      console.log('val: ',val.id);
      console.log('songid: ',songid);
      if(val.id===parseInt(songid)){
        console.log(song + '===' + val);
        song=val;
      }
    });
    this.setState({
      song:song,
      songs:songs
    });
  }
  }

  cancel(e){
    e.preventDefault();
    this.props.cancel();
  }
  edit(e){
    e.preventDefault();
    if(this.props.id===''){
      this.setState({
        submitted:true,
        modaltext:'You gotta log in first.'
      });
      return;
    }
    console.log('editing');
    if(!this.state.editing){
      this.setState({
        editing:true
      });
    }else{
      this.setState({
        editing:false
      });
    }
  }
  submit(title,lyrics,artist,genres,chords){
    let songid = this.state.songid;
    let uid = this.props.id;
    firebase.database()
    .ref('/'+uid+'/songs/'+songid)
    .ref.update({
      title,
      lyrics,
      artist,
      chords,
      moods:genres
    });
    firebase.database()
    .ref(uid+'/songs/'+songid)
    .on('value',(data)=>{
      let song = data.val();
      if(song){
        this.setState({
          song:song,
          songid:songid,
          editing:false
        });
      }
    });


    // this.setState({
    //   editing:false
    // });
  }
  hideModal(){
    this.setState({
      submitted:false
    });
  }
  showChord(e){
    e.preventDefault();
    console.log(e.target.id);
    const id = e.target.id.toString();
    let target = '.'+id;
    console.log('target: ',target);
    const $target = jQuery(target);
    jQuery(target).animate({'opacity':'1'},500);

  }
  hideChord(e){
    e.preventDefault();
    console.log(e.target.id);
    const id = e.target.id.toString();
    let target = '.'+id;
    console.log('target: ',target);
    const $target = jQuery(target);
    jQuery(target).animate({'opacity':'0'},500);

  }
 render(){
    let please_login = (this.state.submitted) ? (<SubmitModal text={this.state.modaltext} hide={this.hideModal.bind(this)}/>) : '';
    console.log('song: ',this.state.song);
    let song = this.state.song;
    let counter = 24;
    const chords = (this.state.song.chords) ? song.chords.map((chord)=>{
      console.log('this chord: ',chord);
      counter++;
      return(
          <span className="songpage_chord_container" id="mememe">
              <button id={counter} onMouseEnter={this.showChord.bind(this)} onMouseLeave={this.hideChord.bind(this)} className="songpage_chord_button btn btn-primary" >
                {chord.name}
              </button>
            <div className={counter.toString()+' songpage_chord_floater'}>
              <ChordDiagram chord={chord} />
            </div>
          </span>
      );
    }) : '';
    let html = (!this.state.editing) ? (
      <div className="songmodal" id={song.id}>
        {/* <span onClick={this.cancel.bind(this)} className="song-close-x">X</span> */}
        <div className="song-btn-row">
          <img className="songmodal_pic" src={song.pic} />
          <div>
            <button onClick={this.edit.bind(this)} className="btn btn-primary song-close">Edit</button>
            <button onClick={this.cancel.bind(this)} className="btn song_edit_btn song-close">Close</button>
          </div>
        </div>
        <h2>{song.title}</h2>
        <p>- {song.artist}</p>
        <div className="songpage_chords">
          {chords}
        </div>
        <div className="lyrics">
          {song.lyrics}
        <br></br>
        <br></br>
        </div>
        {please_login}
      </div>
    )
    : (
      <div>

      <SongEditForm chords={song.chords || []} edit={this.edit.bind(this)} cancel={this.cancel.bind(this)} id={song.id} genres={song.moods} submit={this.submit.bind(this)} title={song.title} artist={song.artist} lyrics={song.lyrics} />
      {please_login}
      </div>
    );
    return(

          <div className="song-show clearfix">{html}</div>

    )
  }
}

export default Song;



// WEBPACK FOOTER //
// ./src/components/Song.js